<div class="detail-field-list-header" *ngIf="heading">
  <h3 class="detail-field-list-title">{{ heading | translate }}</h3>

  <div class="detail-field-list-actions">
    <!-- Block-level actions supplied by the host (e.g. an "edit block" pencil). -->
    <ng-content select="[detailFieldListActions]"></ng-content>
  </div>
</div>

<!-- Block-level extras that belong ABOVE the rows (WB-8420): read-only context
     the configurable fields are then read against. The unattributed
     <ng-content> at the bottom stays the default, so nothing moves unless a
     host opts in with this attribute. -->
<ng-content select="[detailFieldListLead]"></ng-content>

<ng-container *ngFor="let field of fields; trackBy: trackByKey">
  <ui-detail-field
    [field]="field"
    [editable]="editable"
    [slotTemplate]="slotFor(field)"
    (edit)="fieldEdit.emit($event)"
    (valueChange)="onFieldValueChange(field, $event)"
  ></ui-detail-field>

  <!-- Row-level extras, rendered flush under the row they belong to. -->
  <ng-container *ngTemplateOutlet="afterSlotFor(field)"></ng-container>
</ng-container>

<!-- Non-configurable extras that belong to this block (alerts, AI suggestion
     cards, …) are projected below the rows. -->
<ng-content></ng-content>
